import { Action, Reducer } from 'redux';
import {
  BodyshopTypeActionTypes,
  BodyshopTypeState,
  BodyshopTypeTypes
} from './bodyshopTypeTypes';

export const INITIAL_STATE: BodyshopTypeState = {
  bodyshopType: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const bodyshopTypeReducer: Reducer<BodyshopTypeState> = (
  state: BodyshopTypeState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as BodyshopTypeActionTypes;
  switch (actionTypes.type) {
    case BodyshopTypeTypes.GET_BODYSHOP_TYPE:
      return {
        ...state,
        bodyshopType: { ...state.bodyshopType, isLoading: true }
      };
    case BodyshopTypeTypes.SAVE_BODYSHOP_TYPE:
      return {
        ...state,
        bodyshopType: {
          ...state.bodyshopType,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case BodyshopTypeTypes.RESET_REDUCER_BODYSHOP_TYPE:
      return {
        ...state,
        bodyshopType: INITIAL_STATE.bodyshopType
      };
    default:
      return state;
  }
};

export default bodyshopTypeReducer;
